import { makeRouter } from '@adornis/router/client/make-router.js';
import { html } from 'lit';

export const changeMailRouter = makeRouter({
  oldVerified: {
    path: '/old-verified',
    documentTitlePart: 'Alte E-Mail verifiziert',
    render: () => html`
      <div class="flex flex-col w-full justify-center items-center gap-8">
        <span class="icon-[material-symbols--fast-forward-sharp] size-64 text-success"></span>
        <h1 class="text-xl font-semibold">Wir konnten Ihre alte E-Mail erfolgreich verifizieren.</h1>
        <div class="flex flex-col">
          <p>
            Wir sollten soeben eine zweite E-Mail an Ihre neue Adresse versendet haben. Bitte folgen Sie auch hier den
            Anweisungen um die neue E-Mail zu verifizieren. Sie können die Seite nun verlassen.
          </p>
        </div>
      </div>
    `,
  },
  success: {
    path: '/success',
    documentTitlePart: 'E-Mail verifiziert',
    render: () => html`
      <div class="flex flex-col w-full justify-center items-center gap-8">
        <span class="icon-[material-symbols--check-circle-sharp] size-64 text-success"></span>
        <h1 class="text-xl font-semibold">E-Mail-Verifizierung erfolgreich!</h1>
        <div class="flex flex-col">
          <p>Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können die Seite nun verlassen.</p>
        </div>
      </div>
    `,
  },
  confirmError: {
    path: '/confirm-error',
    documentTitlePart: 'Fehler',
    render: () => html`
      <div class="flex flex-col w-full justify-center items-center gap-8">
        <span class="icon-[material-symbols--error-sharp] size-64 text-error"></span>
        <h1 class="text-xl font-semibold">Ein Fehler ist aufgetreten</h1>
        <div class="flex flex-col">
          <p>
            Bei der Bestätigung Ihrer E-Mail-Änderung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder
            kontaktieren Sie uns direkt, sollte der Fehler mehrfach auftreten. Sie können die Seite nun verlassen.
          </p>
        </div>
      </div>
    `,
  },
});
